var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.02395 4.26478L4.7485 7.04595L4.7485 -9.83981e-08L8.21257 -5.70895e-08L8.21257 7.04595L10.9371 4.26478L13 6.34087L6.5 13L7.94094e-08 6.34087L2.02395 4.26478Z","fill":"currentColor"}));
}

Download.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = Download;

Download.default = Download;
